import { useEffect, useState } from 'react';
import { parseEnumType } from './enumMappers';
import { APPLICATION_FUNDING_TYPE } from '../constants';

const useFundingTypeHook = ({ ApplicationFunding, BankApplicationFunding }) => {
  const [applicationFundingType, setApplicationFundingType] = useState('');

  const isCheck =
    applicationFundingType === parseEnumType(APPLICATION_FUNDING_TYPE, 4);
  const isWire =
    applicationFundingType === parseEnumType(APPLICATION_FUNDING_TYPE, 3);

  const isPlaid =
    applicationFundingType === parseEnumType(APPLICATION_FUNDING_TYPE, 1);

  const isCrypto =
    applicationFundingType === parseEnumType(APPLICATION_FUNDING_TYPE, 5);

  useEffect(() => {
    if (ApplicationFunding) {
      const { BankFundingType } = ApplicationFunding;
      setApplicationFundingType(
        parseEnumType(APPLICATION_FUNDING_TYPE, BankFundingType),
      );
    }

    if (BankApplicationFunding) {
      const { BankFundingType } = BankApplicationFunding;

      if (BankFundingType) {
        setApplicationFundingType(
          parseEnumType(APPLICATION_FUNDING_TYPE, BankFundingType),
        );
      }
    }
  }, [ApplicationFunding, BankApplicationFunding]);

  return { isCheck, isWire, isPlaid, isCrypto };
};

useFundingTypeHook.propTypes = {};

export default useFundingTypeHook;
